import select from './list/notificationListSelectors';
export default select;
